import { AccountFeatures, Features } from '@lightspeed-invoicing/core-client/frontend';
import { SHORTCUT_ACTION_TYPE } from "../../state/shortcut/ShortcutAction";

export const objectMapping = {
    //[redirectLink,savePrefType]
    'priceList': ['price-lists', 'listingPriceLists'],
    'subscription': ['recurring-invoices', 'listingRecurringInvoices'],
    'quotes': ['quotes', 'listingQuotes'],
    'orders': ['orders', 'listingOrders'],
    'return': ['returns', 'listingReturns'],
    'invoices': ['invoices', 'listingInvoices'],
}

export const actions = [
    { "actionName": SHORTCUT_ACTION_TYPE.CREATE_CONTACT },
    { "actionName": SHORTCUT_ACTION_TYPE.CREATE_QUOTE },
    { "actionName": SHORTCUT_ACTION_TYPE.CREATE_INVOICE, "feature": Features.Invoice },
    { "actionName": SHORTCUT_ACTION_TYPE.CREATE_ORDER, "feature": AccountFeatures.FeatureOrder },
    { "actionName": SHORTCUT_ACTION_TYPE.CREATE_SUBSCRIPTION, "feature": AccountFeatures.FeatureSubscriptions },
    { "actionName": SHORTCUT_ACTION_TYPE.CREATE_APPOINTMENT, "feature": AccountFeatures.FeatureScheduling },
    { "actionName": SHORTCUT_ACTION_TYPE.CLONE_INVOICE, "feature": Features.Invoice },
    { "actionName": SHORTCUT_ACTION_TYPE.CLONE_QUOTE }]

export const filterObjectsRequiredFeatures = {
    "invoices": [Features.Invoice],
    "returns": [Features.Invoice],
    "recurring-invoices": [Features.Invoice],
    "orders": [AccountFeatures.FeatureOrder],
    "price-lists": [AccountFeatures.FeaturePriceList],
}


// WEBPACK FOOTER //
// ./src/shortcuts/components/helpers.jsx